import { useAuthData } from '@auth/features/auth';
import { useSupportDrawerStore } from '@support/entities/support-ticket';
import { Headset } from 'lucide-react';
import { Button, Tooltip } from '@/shared/ui';
import css from './support-drawer-trigger.module.scss';
import { SupportTicketCountBadge } from './support-ticket-count-badge';

type SupportDrawerTriggerProps = {
  className?: string;
};

// Header trigger, sitting next to "My tasks". Opens the "Support" slide-over
// (My tickets / Recent). Only rendered for roles that can report support
// tickets (support_tickets:create) — its count query never fires for anyone
// else. Mirrors apps/incidents' IncidentDrawerTrigger (own icon + copy).
export const SupportDrawerTrigger = ({
  className,
}: SupportDrawerTriggerProps) => {
  const openDrawer = useSupportDrawerStore((s) => s.openDrawer);
  const { data: authData } = useAuthData();
  const canReport =
    authData?.user.permissions.includes('support_tickets:create') ?? false;

  if (!canReport) return null;

  return (
    <Tooltip content="Support" position="bottom">
      <div className={css.root}>
        <Button
          aria-label="Support"
          className={className}
          icon={<Headset className={css.icon} />}
          onClick={openDrawer}
          size="icon"
          variant="ghost"
        />
        <span className={css.badgeAnchor}>
          <SupportTicketCountBadge />
        </span>
      </div>
    </Tooltip>
  );
};
